import { useMemo } from "react";
import { formatExactDateTooltipLines } from "@helpers/date";
import { useTimeAgo } from "@hooks/useTimeAgo";
import { Tooltip } from "@design-system/Tooltip/Tooltip";

interface RelativeTimeProps {
    date: Date;
    className?: string;
}

/**
 * Relative timestamp ("3d ago") with the exact date in a tooltip, shown in
 * both UTC and the viewer's local timezone so the relative label can be
 * disambiguated without guessing. The label stays current through a shared
 * one-minute ticker and only re-renders when its text changes.
 */
export const RelativeTime = ({ date, className }: RelativeTimeProps) => {
    const label = useTimeAgo(date);
    const { utcLine, localLine } = useMemo(
        () => formatExactDateTooltipLines(date),
        [date],
    );
    return (
        <Tooltip
            content={
                <>
                    {utcLine}
                    <br />
                    {localLine}
                </>
            }
        >
            <span className={className} tabIndex={0}>
                {label}
            </span>
        </Tooltip>
    );
};
